<template>
    <div>
      <b-form @submit.prevent>
        <b-row>
          <!-- Status -->
          <b-col>
            <label for="project-list">Status</label>
            <b-form-select id="project-list"
                           size="sm"
                           class="mr-4"
                           @change="reload"
                           v-model="filter.status"
                           :options="options()"
                           ></b-form-select>
          </b-col>
          <!-- /Status -->
          
        </b-row>
      </b-form>
    </div>
    <!-- /Search detail collapse -->
  </template>
  
  <script>
  export default {
    name: "ChatterProjectFilter",
    computed: {
        filter() {
            return this.$store.getters['project/filter'];
        },
    },
    data() {
      return {
      }
    },
    created() {
    },
    methods: {
        options() {
            let optionsObj =  this.$store.getters['project/options']['projectStatusOptions'];
            let defaultOption = null;
            defaultOption = { value: "", text: "Open" };
            //All, Open, Closed (default: Open)
            return [...optionsObj.slice(0,1), defaultOption,...optionsObj.slice(2,3)];
        
      },
      reload() {
        //this.$store.commit('chatter/setUpdated', 'N');
        this.$emit('reload')
      },
    }
  }
  </script>
  <style>
    .text-container {
        white-space: nowrap;
        /* 텍스트가 줄바꿈되지 않도록 설정 */
        overflow: hidden;
        /* 너비를 초과하는 텍스트를 감추기 */
        text-overflow: ellipsis;
        /* 초과된 텍스트를 "..."으로 표기 */
    }

    /* 신규 추가 스타일 */
    /* import font */
    @import url('https://hangeul.pstatic.net/hangeul_static/css/nanum-gothic.css');

    /* button */
    .project-list .btn {
        border-radius: 10px;
        font-family: 'NanumGothic';
        font-size: 14px;
        font-weight: 500;
        line-height: 150%;
        border: none;
    }

    .project-list .btn:focus {
        box-shadow: none;
    }

    .project-list .btn-secondary {
        width: 148px;
        height: 60px;
        border-radius: 10px;
        background: #747480;
        color: #fff;
    }

    .project-list .btn-secondary.small {
        height: 40px;
    }

    .project-list .btn-secondary:hover {
        background-color: #565662;
    }

    .project-list .btn-secondary.disabled,
    .project-list .btn-secondary:disabled {
        color: #9C9CA8;
        background-color: #C4C4CD;
        border-color: transparent;
    }

    .project-list .btn-primary {
        width: 280px;
        height: 60px;
        background-color: #2E2E38;
        color: #FFE600;
        border-color: transparent;
    }

    .project-list .btn-primary:hover {
        color: #FFE600;
        background-color: #0D0D17;
        border-color: transparent;
    }

    .project-list .btn-primary.disabled,
    .project-list .btn-primary:disabled {
        color: #9C9CA8;
        background-color: #C4C4CD;
        border-color: transparent;
    }

    .project-list .btn-primary.small {
        width: 148px;
        height: 40px;
    }

    .project-list .card-body .btn-wrap {
        display: flex;
        gap: 0 2rem;
        justify-content: end;
        margin-top: 3rem;
        margin-bottom: 1.33rem;
    }

    .project-list .btn-wrap .btn-group-area {
        position: relative;
        display: flex;
        gap: 0 0.666rem;
    }

    .project-list .btn-wrap .btn-group-area::after {
        content: '';
        display: block;
        position: absolute;
        top: 50%;
        right: -1rem;
        transform: translateY(-50%);
        width: 1px;
        height: calc(100% - 1.066rem);
        background-color: #DDDDE3;
    }

    /* select */
    .project-list .custom-select {
        padding: 0.533rem 2.1rem 0.533rem 1.066rem;
        height: 2.666rem;
        border-radius: 10px;
        border: 1px solid #E7E7EE;
        background-color: #F6F6FA;
        background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.834 7.5L10.0007 13.3333L4.16732 7.5" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
        background-position: calc(100% - 12px) 9px;
        background-size: 20px 20px;
        background-repeat: no-repeat;
        font-family: 'NanumGothic';
        color: #2E2E38;
        font-size: 16px;
        font-weight: 400;
        line-height: 150%;
    }

    .project-list .project-list .custom-select:focus {
        border-color: #E7E7EE;
        box-shadow: unset;
    }


    /* input */
    .project-list .label {
        padding-left: 0.4rem;
        margin-bottom: 0.53rem;
        color: #2E2E38;
        font-family: 'NanumGothic';
        font-size: 14px;
        font-weight: 700;
        line-height: 150%;
    }

    input.form-control,
    .project-list .input-group-sm > .form-control {
        padding: 0.533rem 0.8rem 0.533rem 1.066rem;
        height: 2.666rem !important;
        border-radius: 10px !important;
        border: 1px solid #E7E7EE;
        background-color: #F6F6FA;
        font-family: 'NanumGothic';
        color: #2E2E38;
        font-size: 16px;
        font-weight: 400;
        line-height: 150% !important;
    }

    input.form-control::placeholder {
        color: #AAA;
        font-family: 'NanumGothic';
        font-size: 16px;
        font-weight: 400;
        line-height: 150%;
    }

    /* form */
    .project-list .row {
        align-items: flex-end;
        margin-left: -0.7812vw;
        margin-right: -0.7812vw;
    }

    .project-list .row > .col,
    .project-list .row > [class*="col-"] {
        padding-right: 0.78125vw;
        padding-left: 0.7812vw;
    }



    /* info 영역 */
    .info-table-wrap ul {
        padding-left: 0;
    }

    .info-table-wrap li {
        list-style: none;
    }

    .info-table-wrap {
        display: flex;
        flex-wrap: wrap;
        gap: 2.666rem;
        width: 100%;
        margin-bottom: 2.666rem;
        font-family: 'NanumGothic';
    }

    .info-table-wrap .info-table {
        display: flex;
        flex-grow: 1;
        flex-shrink: 0;
        margin-bottom: 0;
        text-decoration: none;
        border-radius: 10px;
        overflow: hidden;
        background-color: #F6F6FA;
        color: #2E2E38;
        font-size: 14px;
    }

    .info-table-wrap .info-table .column {
        width: 50%;
    }

    .info-table-wrap .info-table .column .title {
        font-weight: 700;
        line-height: 60px;
        padding-left: 1.333rem;
    }

    .info-table-wrap .info-table .column .contents {
        padding: 0;
    }

    .info-table-wrap .info-table .column .content {
        line-height: 60px;
        border-bottom: 1px solid #E7E7EE;
        padding: 0 1.333rem;
    }

    .info-table-wrap .info-table .column .content:last-child {
        border-bottom: 0;
    }

    .info-table-wrap .info-table .column .content.blank {
        font-size: 0;
    }

    </style>